<template>
  <div>
    <a-card :bordered="false" :bodyStyle="tstyle">
      <div class="table-page-search-wrapper" v-if="hasPerm('inquiryorder:page')">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="提交时间">
                <a-date-picker style="width: 100%" placeholder="请选择提交时间" @change="onChangectstamp"/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="订单类型">
                <!-- <a-input v-model="queryParam.orderType" allow-clear placeholder="请输入订单类型"/> -->
                <a-select v-model="queryParam.treatType"  allow-clear placeholder="请选择订单类型" :options="treatType"></a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="订单状态">
                <!-- <a-input v-model="queryParam.orderState" allow-clear placeholder="请输入订单状态"/> -->
                <a-select v-model="queryParam.orderState"  allow-clear placeholder="请选择订单状态" :options="orderState"></a-select>
              </a-form-item>
            </a-col>
            
            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="订单编号">
                  <a-input v-model="queryParam.orderCode" allow-clear placeholder="请输入订单编号"/>
                </a-form-item>
              </a-col>
              <!-- <a-col :md="8" :sm="24">
                <a-form-item label="病人ID">
                  <a-input v-model="queryParam.personId" allow-clear placeholder="请输入病人ID"/>
                </a-form-item>
              </a-col> -->
              <a-col :md="8" :sm="24">
                <a-form-item label="姓名">
                  <a-input v-model="queryParam.patientName" allow-clear placeholder="请输入姓名"/>
                </a-form-item>
              </a-col>
              
              <!-- <a-col :md="8" :sm="24">
                <a-form-item label="就诊类型">
                </a-form-item>
              </a-col> -->
              <a-col :md="8" :sm="24">
                <a-form-item label="科室名称">
                  <a-input v-model="queryParam.deptName" allow-clear placeholder="请输入科室名称"/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="手机号">
                  <a-input v-model="queryParam.mobile" allow-clear placeholder="请输入手机号" />
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="8" :sm="24" >
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="$refs.table.refresh(true)" >查询</a-button>
                <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'"/>
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </a-card>
    <a-card :bordered="false">
      <s-table
        ref="table"
        :columns="columns"
        :data="loadData"
        :alert="options.alert"
        :rowKey="(record) => record.orderId"
        :rowSelection="options.rowSelection"
      >
        <template class="table-operator" slot="operator" v-if="hasPerm('inquiryorder:add')" >
          <!-- <a-button type="primary" v-if="hasPerm('inquiryorder:add')" icon="plus" @click="$refs.addForm.add()">新增问诊订单管理</a-button>
          <a-button type="danger" :disabled="selectedRowKeys.length < 1" v-if="hasPerm('inquiryorder:delete')" @click="batchDelete"><a-icon type="delete"/>批量删除</a-button> -->
          <x-down
            v-if="hasPerm('inquiryorder:export')"
            ref="batchExport"
            @batchExport="batchExport"
          />
        </template>


        <span slot="birthday" slot-scope="text, record">
            {{   record.birthday == null? '' : new Date().getFullYear() - parseInt(record.birthday)    }}
        </span>
        <span slot="sex" slot-scope="text, record">
            {{record.sex == '1'? '男' : record.sex == '2'? '女' :  '' }}
        </span>
        <span slot="treatType" slot-scope="text, record">
            {{record.treatType == '0'? '图文问诊' : record.treatType == '1'? '健康咨询' : record.treatType == '2'? '视频问诊' : '' }}
        </span>
        <span slot="orderState" slot-scope="text, record">
            {{record.orderState == '0'? '待支付' : record.orderState == '2'? '已支付' : record.orderState == '4'? '已取消' : '' }}
        </span>

        <span slot="action"  slot-scope="text, record">
          <!-- <a v-if="hasPerm('inquiryorder:edit')" @click="$refs.editForm.edit(record)">编辑</a>
          <a-divider type="vertical" v-if="hasPerm('inquiryorder:edit') & hasPerm('inquiryorder:delete')"/>
          <a-popconfirm v-if="hasPerm('inquiryorder:delete')" placement="topRight" title="确认删除？" @confirm="() => singleDelete(record)">
            <a>删除</a>
          </a-popconfirm> -->
          <a @click="$refs.addForm.add(record)">详情</a>
        </span>
      </s-table>
      <add-form ref="addForm" @ok="handleOk" />
      <edit-form ref="editForm" @ok="handleOk" />
    </a-card>
  </div>
</template>
<script>
  import { STable, XDown } from '@/components'
  import moment from 'moment'
  import { inquiryorderPage, inquiryorderDelete, inquiryorderExport } from '@/api/modular/interhospital/inquiryorder/inquiryorderManage'
  import addForm from './viewDetial.vue'
  import editForm from './editForm.vue'
  export default {
    components: {
      STable,
      addForm,
      editForm,
      XDown
    },
    data () {
      return {
        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {},
        // 表头
        columns: [
          {
            title: '创建时间',
            align: 'center',
            dataIndex: 'ctstamp'
          },
          {
            title: '订单编号',
            align: 'center',
            dataIndex: 'orderId'
          },
          {
            title: '订单类型',
            align: 'center',
            dataIndex: 'treatType',
            scopedSlots: { customRender: 'treatType' },
          },
          {
            title: '姓名',
            align: 'center',
            dataIndex: 'patientname'
          },
          {
            title: '性别',
            align: 'center',
            dataIndex: 'sex',
            scopedSlots: { customRender: 'sex' },
          },
          {
            title: '年龄',
            align: 'center',
            dataIndex: 'birthday',
            scopedSlots: { customRender: 'birthday' },
          },
          {
            title: '科室名称',
            align: 'center',
            dataIndex: 'deptname'
          },
          {
            title: '订单状态',
            align: 'center',
            dataIndex: 'orderState',
            scopedSlots: { customRender: 'orderState' },
          },
          {
            title: '支付金额 ( 元 ) ',
            align: 'center',
            dataIndex: 'feeall'
          },
          
        ],
        treatType : [
          {
            value: '0',
            label: '图文问诊',
          },
          {
            value: '1',
            label: '健康咨询',
          },
          {
            value: '2',
            label: '视频问诊',
          },
        ],
        orderState : [
          {
            value: '',
            label: '全部',
          },
          {
            value: '0',
            label: '待支付',
          },
          {
            value: '2',
            label: '已支付',
          },
          {
            value: '4',
            label: '已取消',
          },
        ],
        tstyle: { 'padding-bottom': '0px', 'margin-bottom': '10px' },
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          return inquiryorderPage(Object.assign(parameter, this.queryParam)).then((res) => {
            return res.data
          })
        },
        selectedRowKeys: [],
        selectedRows: [],
        options: {
          alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
      }
    },
    created () {
      if (this.hasPerm('inquiryorder:edit') || this.hasPerm('inquiryorder:delete')) {
        this.columns.push({
          title: '操作',
          width: '150px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        })
      }
    },
    methods: {
      moment,
      
      /**
       * 单个删除
       */
      singleDelete (record) {
        const param = [{ 'id': record.id }]
        this.inquiryorderDelete(param)
      },
      /**
       * 批量删除
       */
      batchDelete () {
        const paramIds = this.selectedRowKeys.map((d) => {
            return { 'id': d }
        })
        this.inquiryorderDelete(paramIds)
      },
      inquiryorderDelete (record) {
        inquiryorderDelete(record).then((res) => {
          if (res.success) {
            this.$message.success('删除成功')
            this.$refs.table.clearRefreshSelected()
          } else {
            this.$message.error('删除失败') // + res.message
          }
        })
      },
      toggleAdvanced () {
        this.advanced = !this.advanced
      },
      onChangectstamp(date, dateString) {
        this.queryParam.ctstamp = dateString
      },
      /**
       * 批量导出
       */
      batchExport () {
        const paramIds = this.selectedRowKeys.map((d) => {
            return { 'id': d }
        })
        inquiryorderExport(paramIds).then((res) => {
            this.$refs.batchExport.downloadfile(res)
        })
      },
      handleOk () {
        this.$refs.table.refresh()
      },
      onSelectChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      }
    }
  }
</script>
<style lang="less">
  .table-operator {
    margin-bottom: 18px;
  }
  button {
    margin-right: 8px;
  }
</style>
